import {GET_ANSWER_STATUS_START, GET_ANSWER_STATUS_SUCCESS, GET_ANSWER_STATUS_FAIL, GET_ANSWER_STATUS_RESET} from './constants';
import {GetAnswerStatusActions, GetAnswerStatusState} from './types';

const initialState: GetAnswerStatusState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: GetAnswerStatusActions,
): GetAnswerStatusState => {
  switch (action.type) {
    case GET_ANSWER_STATUS_START:
      return {
        ...initialState,
        loading: true,
      };
    case GET_ANSWER_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_ANSWER_STATUS_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_ANSWER_STATUS_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
